import { Component, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import json from 'assets/content/text.json';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-meet-amo',
    templateUrl: './user-about-amo.component.html',
    styleUrls: ['./user-about-amo.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class MeetAmoComponent implements OnInit {
    content = json;

    constructor() {}

    ngOnInit() {/* empty */}
}
